"use strict";
/* This is the starting point of this project
 * so we will write everthing in separates files and
 * re-export everthing from here */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* @TODO:
 * - setup development environemnt:
 *      - add lint, pritter
 *      - setup new config or use the one that belongs to the parent project
 * - write functions/methods that will wrap the api calls
 *      - should handle errors as well
 * - testing
 *      - configure and write testing for this package
 */
__exportStar(require("./lib/client.interface"), exports);
__exportStar(require("./lib/client"), exports);
__exportStar(require("./lib/models/gate"), exports);
__exportStar(require("./lib/models/location"), exports);
__exportStar(require("./lib/models/sublocation"), exports);
__exportStar(require("./lib/models/ioOperation"), exports);
__exportStar(require("./lib/models/events"), exports);
__exportStar(require("./lib/models/eventLog"), exports);
__exportStar(require("./lib/models/session"), exports);
__exportStar(require("./lib/models/locationSharingModel"), exports);
__exportStar(require("./lib/models/region"), exports);
__exportStar(require("./lib/models/enums"), exports);
__exportStar(require("./lib/models/cameraRecording"), exports);
__exportStar(require("./lib/models/cameraRecordingAccessLog"), exports);
__exportStar(require("./lib/models/openingHours"), exports);
__exportStar(require("./lib/models/productOpeningHours"), exports);
__exportStar(require("./lib/models/exceptionDay"), exports);
__exportStar(require("./lib/models/setting"), exports);
__exportStar(require("./lib/models/iotEvents"), exports);
